<mat-card class="price-card" [formGroup]="priceForm">
  <mat-card-header>
    <mat-card-title class="card-title">Update Prices</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="price-inputs">
      <mat-form-field  class="half-width">
        <mat-label>Gold Price (₹)</mat-label>
        <input matInput type="number" formControlName="goldPrice" />
        <mat-error *ngIf="priceForm.get('goldPrice')?.hasError('required')">
          Gold price is required
        </mat-error>
      </mat-form-field>

      <mat-form-field  class="half-width">
        <mat-label>Silver Price (₹)</mat-label>
        <input matInput type="number" formControlName="silverPrice" />
        <mat-error *ngIf="priceForm.get('silverPrice')?.hasError('required')">
          Silver price is required
        </mat-error>
      </mat-form-field>
    </div>
  </mat-card-content>

  <mat-card-actions align="end">
    <button
      mat-raised-button
      class="golden-btn"
      [disabled]="priceForm.invalid"
      (click)="updatePrices()"
    >
      Update
    </button>
  </mat-card-actions>
</mat-card>
